import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ProductListingPageDescriptionUI from 'components/consumer/ProductListingPageDescriptionUI';
const ProductListingPageDescriptionShell = t0 => {
  const $ = _c(3);
  const {
    pageLongDescription: t1,
    pageName: t2
  } = t0;
  const pageLongDescription = t1 === undefined ? "" : t1;
  const pageName = t2 === undefined ? "" : t2;
  if (!pageLongDescription && !pageName) {
    return null;
  }
  let t3;
  if ($[0] !== pageLongDescription || $[1] !== pageName) {
    t3 = <div className="mx-5 md:mx-0 md:mt-24"><ProductListingPageDescriptionUI label={pageName}>{pageLongDescription}</ProductListingPageDescriptionUI></div>;
    $[0] = pageLongDescription;
    $[1] = pageName;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
ProductListingPageDescriptionShell.propTypes = {
  pageLongDescription: PropTypes.string,
  pageName: PropTypes.string
};
export default ProductListingPageDescriptionShell;